import {
  HTTP_SELBRAND_FETCHING,
  HTTP_SELBRAND_SUCCESS,
  HTTP_SELBRAND_FAILED,
  server,
} from "./../../Constants";
import { httpClient } from "././../../utils/HttpClient";

export const setStateSelBrandToFetching = () => ({
  type: HTTP_SELBRAND_FETCHING,
});

export const setStateSelBrandToSuccess = (payload) => ({
  type: HTTP_SELBRAND_SUCCESS,
  payload,
});

export const setStateSelBrandToFailed = (payload) => ({
  type: HTTP_SELBRAND_FAILED,
});

export const getBrands = (countryid, companyid, secureid) => {
  return (dispatch) => {
    dispatch(setStateSelBrandToFetching());

    return httpClient
      .get(`${server.BRAND_URL}/${countryid}/${companyid}/${secureid}`)
      .then((result) => {
        dispatch(setStateSelBrandToSuccess(result.data));
      })
      .catch((err) => {
        dispatch(setStateSelBrandToFailed());
      });
  };
};
